var stabilityEnum = {
    experimental: 'Experimental',
    alpha: 'Alpha',
    beta: 'Beta',
};
export function OpenAPIStability(props) {
    var stability = props.stability;
    var foundStability = stabilityEnum[stability];
    if (!foundStability) {
        return null;
    }
    return (<div className={"openapi-stability openapi-stability-".concat(foundStability.toLowerCase())}>
            {foundStability}
        </div>);
}
